import ServiceAccount from './ServiceAccount';

export default ServiceAccount;
